import { LOCALES } from 'i18n/locales';

export const dynamicLegendButtonIntl = {
    [LOCALES.ENGLISH]: {
        'dynamicLegend.altText': 'View dynamic legend',
        'dynamicLegend.heading': 'Dynamic legend'
    },
    [LOCALES.WELSH]: {
        'dynamicLegend.altText': 'Gweld eglurhad dynamig',
        'dynamicLegend.heading': 'Allwedd ddynamig'
    }
};
